import placekit from '@placekit/client-js';
import { useEffect, useState } from 'react';

const pk = placekit(process.env.NEXT_PUBLIC_PLACEKIT_API_KEY);

const storageKey = 'ip-based-coordinates';
export const useIPCoordinates = () => {
  const [coords, setCoords] = useState('');

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const cached = sessionStorage.getItem(storageKey);
    // 'undefined' was cached by earlier versions when the IP lookup found nothing.
    if (cached && cached !== 'undefined') {
      setCoords(cached);
    } else {
      // An IP the API can't place returns no results: keep '' so the demos fall back
      // to their default location instead of receiving `undefined`.
      pk.reverse()
        .then(({ results }) => {
          const coordinates = results?.[0]?.coordinates;
          if (!coordinates) return;
          sessionStorage.setItem(storageKey, coordinates);
          setCoords(coordinates);
        })
        .catch(() => {});
    }
  }, []);

  return [coords, setCoords];
};
